/**
 * @file コンポーネント：フル動画ページローディングエラーモーダル DOM管理
 */

// ライブラリ読み込み
import React from "react";
import ReactDOMServer from "react-dom/server";

// コンポーネント読み込み
import { Modal } from "~/src/components/projects/Modal";
import { Paragraph } from "~/src/components/uiparts/Paragraph";

// 関数読み込み
import {
    fnGetCultureLanguage,
    fnReplaceLocalizedText,
} from "~/src/functions/common";

// スタイル読み込み
import { StyledErrorLoadingAnchor } from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    // ReactDOM
    return (
        <Modal
            content={
                <>
                    <Paragraph
                        key="ModalErrorLoadingText1"
                        onColor="white"
                        text={fnReplaceLocalizedText(
                            localized["Label.ModalErrorLoadingText1"],
                            [
                                ReactDOMServer.renderToString(
                                    <StyledErrorLoadingAnchor href="/accessibility">
                                        {fnGetCultureLanguage() === "ja"
                                            ? "推奨環境ページ"
                                            : "System Requirement Page"}
                                    </StyledErrorLoadingAnchor>
                                ),
                            ]
                        )}
                    />
                    <Paragraph
                        key="ModalErrorLoadingText2"
                        onColor="white"
                        text={fnReplaceLocalizedText(
                            localized["Label.ModalErrorLoadingText2"],
                            [
                                ReactDOMServer.renderToString(
                                    <StyledErrorLoadingAnchor
                                        key="ErrorLoadingAnchor"
                                        href={
                                            fnGetCultureLanguage() === "ja"
                                                ? "https://opexpark.notion.site/Q-786a51d8859e441caa309f06aef3f403"
                                                : "https://opexpark.notion.site/Q-If-videos-are-not-playing-de95517cde654fb09045b417a1892010"
                                        }
                                        target="_blank"
                                    >
                                        {fnGetCultureLanguage() === "ja"
                                            ? "こちら"
                                            : "How to Adjust the Browser Settings"}
                                    </StyledErrorLoadingAnchor>
                                ),
                            ]
                        )}
                    />
                </>
            }
            hasButtonClose={true}
            isShow={true}
            setIsShow={props.setIsShow}
        />
    );
};
